var Colors;
(function (Colors) {
    Colors["White"] = "#FFFFFF";
    Colors["Black"] = "#000000";
    Colors["Black2"] = "#141414";
    Colors["Yellow"] = "#FFBA49";
    // Green = "#419D78",
    Colors["Green"] = "#42BB83";
    Colors["OffWhite"] = "#FCFCFC";
    Colors["LightBlue"] = "#39159C";
    Colors["Secondary"] = "#1E1E1E";
    Colors["Blue"] = "#2D0E84";
    Colors["DarkBlue"] = "#1D0858";
    Colors["Red"] = "#E63946";
    Colors["Orange"] = "#FF700F";
    Colors["FadedOrange"] = "#FFF1E7";
    Colors["LightOrange"] = "#FFBE93";
    Colors["DarkOrange"] = "#D65600";
    Colors["Grey1"] = "#333333";
    Colors["Grey2"] = "#4F4F4F";
    Colors["Grey3"] = "#828282";
    Colors["Grey4"] = "#BDBDBD";
    Colors["Grey5"] = "#E0E0E0";
    Colors["Grey6"] = "#F2F2F2";
    Colors["Grey7"] = "#F8F8F8";
    Colors["Grey8"] = "#424242";
    Colors["Purple"] = "#040436";
    Colors["SecondarySurface"] = "#1E1E1E";
    Colors["SecondaryStroke"] = "#424242";
    Colors["SurfaceTertiary"] = "#141414";
    Colors["HeadingSecondary"] = "#FCFCFC";
    Colors["SupportTertiary"] = "#A3A3A3";
    Colors["HeadingPrimary"] = "#EF602E";
    Colors["InteractiveBGSecondary"] = "#292929";
    Colors["InteractiveBGPrimary"] = "#EA4513";
    Colors["TagBGTertiary"] = "#0C0C0C";
    Colors["TextSupportSecondary"] = "#D6D6D6";
    Colors["ErrorRed"] = "#F31B43";
})(Colors || (Colors = {}));

export { Colors };
//# sourceMappingURL=Colors.js.map
